export function renderTrashIcon(): string {
  return `
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M9 3h6l1 2h4v2H4V5h4l1-2Zm1 7h2v8h-2v-8Zm4 0h2v8h-2v-8ZM7 10h2v8H7v-8Zm1 11a2 2 0 0 1-2-2V8h12v11a2 2 0 0 1-2 2H8Z" fill="currentColor"></path>
    </svg>
  `;
}

export function renderVisibilityIcon(hidden: boolean): string {
  if (hidden) {
    return `
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="m4 4 16 16-1.4 1.4-2.4-2.4A11.4 11.4 0 0 1 12 20C6.6 20 2.3 16.8 1 12c.7-2.3 2-4.3 3.8-5.8L2.6 5.4 4 4Zm4.3 4.3A4 4 0 0 0 12 16c.6 0 1.1-.1 1.6-.3L8.3 8.3ZM12 4c5.4 0 9.7 3.2 11 8-.5 1.8-1.4 3.5-2.7 4.9l-2.9-2.9c.4-.6.6-1.3.6-2a4 4 0 0 0-4-4c-.7 0-1.4.2-2 .6L9.9 6.5C10.6 6.2 11.3 4 12 4Z" fill="currentColor"></path>
      </svg>
    `;
  }

  return `
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 5c5.4 0 9.7 3.2 11 7-1.3 3.8-5.6 7-11 7S2.3 15.8 1 12c1.3-3.8 5.6-7 11-7Zm0 2C8 7 4.8 9.1 3.2 12 4.8 14.9 8 17 12 17s7.2-2.1 8.8-5C19.2 9.1 16 7 12 7Zm0 2.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z" fill="currentColor"></path>
    </svg>
  `;
}
